export default __webpack_public_path__ + "static/media/SWEET-PAIN.c80e51ad.png";